/*=========================================================================================
  File Name: module-layouttax.js
  Description: layoutTax Module
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

import state from './module-layout-state';
import mutations from './module-layout-mutations';
import actions from './module-layout-actions';
import getters from './module-layout-getters';

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
